import axios from 'axios';
import qs from 'qs';
import CryptoJS from 'crypto-js';
import { Toast } from 'antd-mobile-v2';
import { isAfter } from 'date-fns';

import { getRefreshToken, logOut } from '@service/user.service';
import { signParams } from '@yqz/base';

export function isAccTokenExpired(token: string): boolean {
  if (token) {
    const tokenContent = token.split('.')[1];
    const tokenString = CryptoJS.enc.Base64.parse(tokenContent).toString(
      CryptoJS.enc.Utf8,
    );
    const tokenObj = JSON.parse(tokenString);
    const now = new Date().getTime();
    // 过期时间前5秒即视为过期,同时考虑到前端到服务器的延迟再多减5秒
    const expireDate = (tokenObj.exp - 10) * 1000;
    return isAfter(now, expireDate);
  } else {
    return false;
  }
  // return true;
}

export async function refreshAccessToken(): Promise<string> {
  const accessToken = window.accessToken;
  const refreshToken = getRefreshToken();
  const res: any = await axios.request({
    baseURL: process.env.REACT_APP_BINGOHOME_API,
    url: '/login/refreshAccessToken.do',
    method: 'post',
    timeout: 8000,
    params: {
      refreshToken,
      accessToken,
    },
    paramsSerializer: function (params) {
      const p = signParams({ ...params,pl_user: 'react_worker' }, process.env.REACT_APP_SECRET || '');
      return qs.stringify(p, { arrayFormat: 'repeat' });
    },
  });

  if (res.data.code === 200 || res.data.code === '200') {
    console.log(`[refreshAccessToken] success`);
  } else {
    console.log(`[refreshAccessToken] failed ${JSON.stringify(res.data)}`);
    Toast.info('登录凭证过期,请重新登录', 2);
    logOut();
    return '';
  }
  return res.data.data;
}
